/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../common";
import type {
  OpenBloxL1,
  OpenBloxL1Interface,
} from "../../../../contracts/token/OpenBlox/OpenBloxL1";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "burnBlox",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getBlox",
    outputs: [
      {
        internalType: "uint256",
        name: "genes",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "bornAt",
        type: "uint256",
      },
      {
        internalType: "uint16",
        name: "generation",
        type: "uint16",
      },
      {
        internalType: "uint256",
        name: "parent0Id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "parent1Id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "ancestorCode",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "reproduction",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "increaseReproduction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "genes",
        type: "uint256",
      },
      {
        internalType: "uint16",
        name: "generation",
        type: "uint16",
      },
      {
        internalType: "uint256",
        name: "parent0Id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "parent1Id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "ancestorCode",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
    ],
    name: "mintBlox",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x60806040523480156200001157600080fd5b506040518060400160405280600581526020017f4c314e46540000000000000000000000000000000000000000000000000000008152506040518060400160405280600581526020017f4c314e46540000000000000000000000000000000000000000000000000000008152506200009e62000092620000ca60201b60201c565b620000d260201b60201c565b8160019081620000af919062000410565b508060029081620000c1919062000410565b505050620004f7565b600033905090565b60008060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff169050816000806101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff1602179055508173ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff167f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e060405160405180910390a35050565b600081519050919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052604160045260246000fd5b7f4e487b7100000000000000000000000000000000000000000000000000000000600052602260045260246000fd5b600060028204905060018216806200021857607f821691505b6020821081036200022e576200022d620001d0565b5b50919050565b60008190508160005260206000209050919050565b60006020601f8301049050919050565b600082821b905092915050565b600060088302620002987fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff8262000259565b620002a4868362000259565b95508019841693508086168417925050509392505050565b6000819050919050565b6000819050919050565b6000620002f1620002eb620002e584620002bc565b620002c6565b620002bc565b9050919050565b6000819050919050565b6200030d83620002d0565b620003256200031c82620002f8565b84845462000266565b825550505050565b600090565b6200033c6200032d565b6200034981848462000302565b505050565b5b8181101562000371576200036560008262000332565b6001810190506200034f565b5050565b601f821115620003c0576200038a8162000234565b620003958462000249565b81016020851015620003a5578190505b620003bd620003b48562000249565b8301826200034e565b50505b505050565b600082821c905092915050565b6000620003e560001984600802620003c5565b1980831691505092915050565b6000620004008383620003d2565b9150826002028217905092915050565b6200041b8262000196565b67ffffffffffffffff811115620004375762000436620001a1565b5b620004438254620001ff565b6200045082828562000375565b600060209050601f83116001811462000488576000841562000473578287015190505b6200047f8582620003f2565b865550620004ef565b601f198416620004988662000234565b60005b82811015620004c2578489015182556001820191506020850194506020810190506200049b565b86831015620004e25784890151620004de601f891682620003d2565b8355505b6001600288020188555050505b505050505050565b61303680620005076000396000f3fe608060405234801561001057600080fd5b50600436106101365760003560e01c8063715018a6116100b8578063a22cb4651161007c578063a22cb4651461033d578063a9e3df7114610359578063b88d4fde14610375578063c87b56dd14610391578063e985e9c5146103c1578063f2fde38b146103f157610136565b8063715018a6146102a557806382e402d4146102af5780638da5cb5b146102e55780638fce08df1461030357806395d89b411461031f57610136565b806323b872dd116100ff57806323b872dd146101f157806342842e0e1461020d57806342966c68146102295780636352211e1461024557806370a082311461027557610136565b80624678251461013b57806301ffc9a71461015757806306fdde0314610187578063081812fc146101a5578063095ea7b3146101d5575b600080fd5b61015560048036038101906101509190611f3a565b61040d565b005b610171600480360381019061016c9190611fbf565b610469565b60405161017e9190612007565b60405180910390f35b61018f61054b565b60405161019c91906120b2565b60405180910390f35b6101bf60048036038101906101ba9190611f3a565b6105dd565b6040516101cc9190612115565b60405180910390f35b6101ef60048036038101906101ea919061215c565b610623565b005b61020b6004803603810190610206919061219c565b61073a565b005b6102276004803603810190610222919061219c565b61079a565b005b610243600480360381019061023e9190611f3a565b6107ba565b005b61025f600480360381019061025a9190611f3a565b610816565b60405161026c9190612115565b60405180910390f35b61028f600480360381019061028a91906121ef565b61089c565b60405161029c919061222b565b60405180910390f35b6102ad610953565b005b6102c960048036038101906102c49190611f3a565b610967565b6040516102dc979695949392919061227f565b60405180910390f35b6102ed610a29565b6040516102fa9190612115565b60405180910390f35b61031d6004803603810190610318919061231a565b610a52565b005b610327610a6d565b60405161033491906120b2565b60405180910390f35b610357600480360381019061035291906123e8565b610aff565b005b610373600480360381019061036e9190611f3a565b610b15565b005b61038f600480360381019061038a919061255d565b610b6b565b005b6103ab60048036038101906103a69190611f3a565b610bcd565b6040516103b891906120b2565b60405180910390f35b6103db60048036038101906103d691906125e0565b610c35565b6040516103e89190612007565b60405180910390f35b61040b600480360381019061040691906121ef565b610cc9565b005b61041e610418610d4c565b82610d54565b61045d576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161045490612692565b60405180910390fd5b61046681610de9565b50565b60007f80ac58cd000000000000000000000000000000000000000000000000000000007bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916827bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916148061053457507f5b5e139f000000000000000000000000000000000000000000000000000000007bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916827bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916145b80610544575061054382610e5c565b5b9050919050565b60606001805461055a906126e1565b80601f0160208091040260200160405190810160405280929190818152602001828054610586906126e1565b80156105d35780601f106105a8576101008083540402835291602001916105d3565b820191906000526020600020905b8154815290600101906020018083116105b657829003601f168201915b5050505050905090565b60006105e882610ec6565b6005600083815260200190815260200160002060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff169050919050565b600061062e82610816565b90508073ffffffffffffffffffffffffffffffffffffffff168373ffffffffffffffffffffffffffffffffffffffff160361069e576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161069590612784565b60405180910390fd5b8073ffffffffffffffffffffffffffffffffffffffff166106bd610d4c565b73ffffffffffffffffffffffffffffffffffffffff1614806106ec57506106eb816106e6610d4c565b610c35565b5b61072b576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161072290612816565b60405180910390fd5b6107358383610f11565b505050565b61074b610745610d4c565b82610d54565b61078a576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610781906128a8565b60405180910390fd5b610795838383610fca565b505050565b6107b583838360405180602001604052806000815250610b6b565b505050565b6107cb6107c5610d4c565b82610d54565b61080a576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610801906128a8565b60405180910390fd5b610813816112bf565b50565b60008061082283611409565b9050600073ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff1603610893576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161088a90612914565b60405180910390fd5b80915050919050565b60008073ffffffffffffffffffffffffffffffffffffffff168273ffffffffffffffffffffffffffffffffffffffff160361090c576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610903906129a6565b60405180910390fd5b600460008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020549050919050565b61095b611446565b61096560006114c4565b565b600080600080600080600061097b88611588565b6109ba576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016109b190612a12565b60405180910390fd5b6000600760008a81526020019081526020016000209050806000015481600101548260020160009054906101000a900461ffff168360030154846004015485600501548660060160009054906101000a900460ff16975097509750975097509750975050919395979092949650565b60008060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff16905090565b610a64878288428989898960006115c9565b50505050505050565b606060028054610a7c906126e1565b80601f0160208091040260200160405190810160405280929190818152602001828054610aa8906126e1565b8015610af55780601f10610aca57610100808354040283529160200191610af5565b820191906000526020600020905b815481529060010190602001808311610ad857829003601f168201915b5050505050905090565b610b11610b0a610d4c565b83836116aa565b5050565b610b1d611446565b60016007600083815260200190815260200160002060060160008282829054906101000a900460ff16610b509190612a61565b92506101000a81548160ff021916908360ff16021790555050565b610b7c610b76610d4c565b83610d54565b610bbb576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610bb2906128a8565b60405180910390fd5b610bc784848484611816565b50505050565b6060610bd882610ec6565b6000610be2611872565b90506000815111610c025760405180602001604052806000815250610c2d565b80610c0c84611889565b604051602001610c1d929190612ad2565b6040516020818303038152906040525b915050919050565b6000600660008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060009054906101000a900460ff16905092915050565b610cd1611446565b600073ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff1603610d40576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610d3790612b68565b60405180910390fd5b610d49816114c4565b50565b600033905090565b600080610d6083610816565b90508073ffffffffffffffffffffffffffffffffffffffff168473ffffffffffffffffffffffffffffffffffffffff161480610da25750610da18185610c35565b5b80610de057508373ffffffffffffffffffffffffffffffffffffffff16610dc8846105dd565b73ffffffffffffffffffffffffffffffffffffffff16145b91505092915050565b610df2816112bf565b6007600082815260200190815260200160002060008082016000905560018201600090556002820160006101000a81549061ffff02191690556003820160009055600482016000905560058201600090556006820160006101000a81549060ff0219169055505050565b60007f01ffc9a7000000000000000000000000000000000000000000000000000000007bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916827bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916149050919050565b610ecf81611588565b610f0e576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610f0590612914565b60405180910390fd5b50565b816005600083815260200190815260200160002060006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff160217905550808273ffffffffffffffffffffffffffffffffffffffff16610f8483610816565b73ffffffffffffffffffffffffffffffffffffffff167f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b92560405160405180910390a45050565b8273ffffffffffffffffffffffffffffffffffffffff16610fea82610816565b73ffffffffffffffffffffffffffffffffffffffff1614611040576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161103790612bfa565b60405180910390fd5b600073ffffffffffffffffffffffffffffffffffffffff168273ffffffffffffffffffffffffffffffffffffffff16036110af576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016110a690612c8c565b60405180910390fd5b6110ba838383611957565b8273ffffffffffffffffffffffffffffffffffffffff166110da82610816565b73ffffffffffffffffffffffffffffffffffffffff1614611130576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161112790612bfa565b60405180910390fd5b6005600082815260200190815260200160002060006101000a81549073ffffffffffffffffffffffffffffffffffffffff02191690556001600460008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020600082825403925050819055506001600460008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008282540192505081905550816003600083815260200190815260200160002060006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff160217905550808273ffffffffffffffffffffffffffffffffffffffff168473ffffffffffffffffffffffffffffffffffffffff167fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef60405160405180910390a46112ba83838361195c565b505050565b60006112ca82610816565b90506112d881600084611957565b6112e182610816565b90506005600083815260200190815260200160002060006101000a81549073ffffffffffffffffffffffffffffffffffffffff02191690556001600460008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020600082825403925050819055506003600083815260200190815260200160002060006101000a81549073ffffffffffffffffffffffffffffffffffffffff021916905581600073ffffffffffffffffffffffffffffffffffffffff168273ffffffffffffffffffffffffffffffffffffffff167fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef60405160405180910390a46114058160008461195c565b5050565b60006003600083815260200190815260200160002060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff169050919050565b61144e610d4c565b73ffffffffffffffffffffffffffffffffffffffff1661146c610a29565b73ffffffffffffffffffffffffffffffffffffffff16146114c2576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016114b990612cf8565b60405180910390fd5b565b60008060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff169050816000806101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff1602179055508173ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff167f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e060405160405180910390a35050565b60008073ffffffffffffffffffffffffffffffffffffffff166115aa83611409565b73ffffffffffffffffffffffffffffffffffffffff1614159050919050565b60006040518060e001604052808981526020018881526020018761ffff1681526020018681526020018581526020018481526020018360ff168152509050611611898b611961565b80600760008c8152602001908152602001600020600082015181600001556020820151816001015560408201518160020160006101000a81548161ffff021916908361ffff160217905550606082015181600301556080820151816004015560a0820151816005015560c08201518160060160006101000a81548160ff021916908360ff16021790555090505050505050505050505050565b8173ffffffffffffffffffffffffffffffffffffffff168373ffffffffffffffffffffffffffffffffffffffff1603611718576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161170f90612d64565b60405180910390fd5b80600660008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060006101000a81548160ff0219169083151502179055508173ffffffffffffffffffffffffffffffffffffffff168373ffffffffffffffffffffffffffffffffffffffff167f17307eab39ab6107e8899845ad3d59bd9653f200f220920489ca2b5937696c31836040516118099190612007565b60405180910390a3505050565b611821848484610fca565b61182d8484848461197f565b61186c576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161186390612df6565b60405180910390fd5b50505050565b606060405180602001604052806000815250905090565b60606000600161189884611b06565b01905060008167ffffffffffffffff8111156118b7576118b6612432565b5b6040519080825280601f01601f1916602001820160405280156118e95781602001600182028036833780820191505090505b509050600082602001820190505b60011561194c578080600190039150507f3031323334353637383961626364656600000000000000000000000000000000600a86061a8153600a85816119405761193f612e16565b5b049450600085036118f7575b819350505050919050565b505050565b505050565b61197b828260405180602001604052806000815250611c59565b5050565b60006119a08473ffffffffffffffffffffffffffffffffffffffff16611cb4565b15611af9578373ffffffffffffffffffffffffffffffffffffffff1663150b7a026119c9610d4c565b8786866040518563ffffffff1660e01b81526004016119eb9493929190612e9a565b6020604051808303816000875af1925050508015611a2757506040513d601f19601f82011682018060405250810190611a249190612efb565b60015b611aa9573d8060008114611a57576040519150601f19603f3d011682016040523d82523d6000602084013e611a5c565b606091505b506000815103611aa1576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401611a9890612df6565b60405180910390fd5b805181602001fd5b63150b7a0260e01b7bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916817bffffffffffffffffffffffffffffffffffffffffffffffffffffffff191614915050611afe565b600190505b949350505050565b600080600090507a184f03e93ff9f4daa797ed6e38ed64bf6a1f0100000000000000008310611b64577a184f03e93ff9f4daa797ed6e38ed64bf6a1f0100000000000000008381611b5a57611b59612e16565b5b0492506040810190505b6d04ee2d6d415b85acef81000000008310611ba1576d04ee2d6d415b85acef81000000008381611b9757611b96612e16565b5b0492506020810190505b662386f26fc100008310611bd057662386f26fc100008381611bc657611bc5612e16565b5b0492506010810190505b6305f5e1008310611bf9576305f5e1008381611bef57611bee612e16565b5b0492506008810190505b6127108310611c1e576127108381611c1457611c13612e16565b5b0492506004810190505b60648310611c415760648381611c3757611c36612e16565b5b0492506002810190505b600a8310611c50576001810190505b80915050919050565b611c638383611cd7565b611c70600084848461197f565b611caf576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401611ca690612df6565b60405180910390fd5b505050565b6000808273ffffffffffffffffffffffffffffffffffffffff163b119050919050565b600073ffffffffffffffffffffffffffffffffffffffff168273ffffffffffffffffffffffffffffffffffffffff1603611d46576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401611d3d90612f74565b60405180910390fd5b611d4f81611588565b15611d8f576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401611d8690612fe0565b60405180910390fd5b611d9b60008383611957565b611da481611588565b15611de4576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401611ddb90612fe0565b60405180910390fd5b6001600460008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008282540192505081905550816003600083815260200190815260200160002060006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff160217905550808273ffffffffffffffffffffffffffffffffffffffff16600073ffffffffffffffffffffffffffffffffffffffff167fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef60405160405180910390a4611eec6000838361195c565b5050565b6000604051905090565b600080fd5b600080fd5b6000819050919050565b611f1781611f04565b8114611f2257600080fd5b50565b600081359050611f3481611f0e565b92915050565b600060208284031215611f5057611f4f611efa565b5b6000611f5e84828501611f25565b91505092915050565b60007fffffffff0000000000000000000000000000000000000000000000000000000082169050919050565b611f9c81611f67565b8114611fa757600080fd5b50565b600081359050611fb981611f93565b92915050565b600060208284031215611fd557611fd4611efa565b5b6000611fe384828501611faa565b91505092915050565b60008115159050919050565b61200181611fec565b82525050565b600060208201905061201c6000830184611ff8565b92915050565b600081519050919050565b600082825260208201905092915050565b60005b8381101561205c578082015181840152602081019050612041565b60008484015250505050565b6000601f19601f8301169050919050565b600061208482612022565b61208e818561202d565b935061209e81856020860161203e565b6120a781612068565b840191505092915050565b600060208201905081810360008301526120cc8184612079565b905092915050565b600073ffffffffffffffffffffffffffffffffffffffff82169050919050565b60006120ff826120d4565b9050919050565b61210f816120f4565b82525050565b600060208201905061212a6000830184612106565b92915050565b612139816120f4565b811461214457600080fd5b50565b60008135905061215681612130565b92915050565b6000806040838503121561217357612172611efa565b5b600061218185828601612147565b925050602061219285828601611f25565b9150509250929050565b6000806000606084860312156121b5576121b4611efa565b5b60006121c386828701612147565b93505060206121d486828701612147565b92505060406121e586828701611f25565b9150509250925092565b60006020828403121561220557612204611efa565b5b600061221384828501612147565b91505092915050565b61222581611f04565b82525050565b6000602082019050612240600083018461221c565b92915050565b600061ffff82169050919050565b61225d81612246565b82525050565b600060ff82169050919050565b61227981612263565b82525050565b600060e082019050612294600083018a61221c565b6122a1602083018961221c565b6122ae6040830188612254565b6122bb606083018761221c565b6122c8608083018661221c565b6122d560a083018561221c565b6122e260c0830184612270565b98975050505050505050565b6122f781612246565b811461230257600080fd5b50565b600081359050612314816122ee565b92915050565b600080600080600080600060e0888a03121561233957612338611efa565b5b60006123478a828b01611f25565b97505060206123588a828b01611f25565b96505060406123698a828b01612305565b955050606061237a8a828b01611f25565b945050608061238b8a828b01611f25565b93505060a061239c8a828b01611f25565b92505060c06123ad8a828b01612147565b91505092959891949750929550565b6123c581611fec565b81146123d057600080fd5b50565b6000813590506123e2816123bc565b92915050565b600080604083850312156123ff576123fe611efa565b5b600061240d85828601612147565b925050602061241e858286016123d3565b9150509250929050565b600080fd5b600080fd5b7f4e487b7100000000000000000000000000000000000000000000000000000000600052604160045260246000fd5b61246a82612068565b810181811067ffffffffffffffff8211171561248957612488612432565b5b80604052505050565b600061249c611ef0565b90506124a88282612461565b919050565b600067ffffffffffffffff8211156124c8576124c7612432565b5b6124d182612068565b9050602081019050919050565b82818337600083830152505050565b60006125006124fb846124ad565b612492565b90508281526020810184848401111561251c5761251b61242d565b5b6125278482856124de565b509392505050565b600082601f83011261254457612543612428565b5b81356125548482602086016124ed565b91505092915050565b6000806000806080858703121561257757612576611efa565b5b600061258587828801612147565b945050602061259687828801612147565b93505060406125a787828801611f25565b925050606085013567ffffffffffffffff8111156125c8576125c7611eff565b5b6125d48782880161252f565b91505092959194509250565b600080604083850312156125f7576125f6611efa565b5b600061260585828601612147565b925050602061261685828601612147565b9150509250929050565b7f4f70656e426c6f784c313a206e6f74206f776e6572206e6f7220617070726f7660008201527f6564000000000000000000000000000000000000000000000000000000000000602082015250565b600061267c60228361202d565b915061268782612620565b604082019050919050565b600060208201905081810360008301526126ab8161266f565b9050919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052602260045260246000fd5b600060028204905060018216806126f957607f821691505b60208210810361270c5761270b6126b2565b5b50919050565b7f4552433732313a20617070726f76616c20746f2063757272656e74206f776e6560008201527f7200000000000000000000000000000000000000000000000000000000000000602082015250565b600061276e60218361202d565b915061277982612712565b604082019050919050565b6000602082019050818103600083015261279d81612761565b9050919050565b7f4552433732313a20617070726f76652063616c6c6572206973206e6f7420746f60008201527f6b656e206f776e6572206f7220617070726f76656420666f7220616c6c000000602082015250565b6000612800603d8361202d565b915061280b826127a4565b604082019050919050565b6000602082019050818103600083015261282f816127f3565b9050919050565b7f4552433732313a2063616c6c6572206973206e6f7420746f6b656e206f776e6560008201527f72206f7220617070726f76656400000000000000000000000000000000000000602082015250565b6000612892602d8361202d565b915061289d82612836565b604082019050919050565b600060208201905081810360008301526128c181612885565b9050919050565b7f4552433732313a20696e76616c696420746f6b656e2049440000000000000000600082015250565b60006128fe60188361202d565b9150612909826128c8565b602082019050919050565b6000602082019050818103600083015261292d816128f1565b9050919050565b7f4552433732313a2061646472657373207a65726f206973206e6f74206120766160008201527f6c6964206f776e65720000000000000000000000000000000000000000000000602082015250565b600061299060298361202d565b915061299b82612934565b604082019050919050565b600060208201905081810360008301526129bf81612983565b9050919050565b7f4f70656e426c6f784c313a206e6f6e6578697374656e7420746f6b656e496400600082015250565b60006129fc601f8361202d565b9150612a07826129c6565b602082019050919050565b60006020820190508181036000830152612a2b816129ef565b9050919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601160045260246000fd5b6000612a6c82612263565b9150612a7783612263565b9250828201905060ff811115612a9057612a8f612a32565b5b92915050565b600081905092915050565b6000612aac82612022565b612ab68185612a96565b9350612ac681856020860161203e565b80840191505092915050565b6000612ade8285612aa1565b9150612aea8284612aa1565b91508190509392505050565b7f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160008201527f6464726573730000000000000000000000000000000000000000000000000000602082015250565b6000612b5260268361202d565b9150612b5d82612af6565b604082019050919050565b60006020820190508181036000830152612b8181612b45565b9050919050565b7f4552433732313a207472616e736665722066726f6d20696e636f72726563742060008201527f6f776e6572000000000000000000000000000000000000000000000000000000602082015250565b6000612be460258361202d565b9150612bef82612b88565b604082019050919050565b60006020820190508181036000830152612c1381612bd7565b9050919050565b7f4552433732313a207472616e7366657220746f20746865207a65726f2061646460008201527f7265737300000000000000000000000000000000000000000000000000000000602082015250565b6000612c7660248361202d565b9150612c8182612c1a565b604082019050919050565b60006020820190508181036000830152612ca581612c69565b9050919050565b7f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572600082015250565b6000612ce260208361202d565b9150612ced82612cac565b602082019050919050565b60006020820190508181036000830152612d1181612cd5565b9050919050565b7f4552433732313a20617070726f766520746f2063616c6c657200000000000000600082015250565b6000612d4e60198361202d565b9150612d5982612d18565b602082019050919050565b60006020820190508181036000830152612d7d81612d41565b9050919050565b7f4552433732313a207472616e7366657220746f206e6f6e20455243373231526560008201527f63656976657220696d706c656d656e7465720000000000000000000000000000602082015250565b6000612de060328361202d565b9150612deb82612d84565b604082019050919050565b60006020820190508181036000830152612e0f81612dd3565b9050919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601260045260246000fd5b600081519050919050565b600082825260208201905092915050565b6000612e6c82612e45565b612e768185612e50565b9350612e8681856020860161203e565b612e8f81612068565b840191505092915050565b6000608082019050612eaf6000830187612106565b612ebc6020830186612106565b612ec9604083018561221c565b8181036060830152612edb8184612e61565b905095945050505050565b600081519050612ef581611f93565b92915050565b600060208284031215612f1157612f10611efa565b5b6000612f1f84828501612ee6565b91505092915050565b7f4552433732313a206d696e7420746f20746865207a65726f2061646472657373600082015250565b6000612f5e60208361202d565b9150612f6982612f28565b602082019050919050565b60006020820190508181036000830152612f8d81612f51565b9050919050565b7f4552433732313a20746f6b656e20616c7265616479206d696e74656400000000600082015250565b6000612fca601c8361202d565b9150612fd582612f94565b602082019050919050565b60006020820190508181036000830152612ff981612fbd565b905091905056fea26469706673582212209c3192fb8a4a8c11f61be0a349f0f2b2bc4a9cfc3c8745bf224119395664e38164736f6c63430008110033";

type OpenBloxL1ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: OpenBloxL1ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class OpenBloxL1__factory extends ContractFactory {
  constructor(...args: OpenBloxL1ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<OpenBloxL1> {
    return super.deploy(overrides || {}) as Promise<OpenBloxL1>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): OpenBloxL1 {
    return super.attach(address) as OpenBloxL1;
  }
  override connect(signer: Signer): OpenBloxL1__factory {
    return super.connect(signer) as OpenBloxL1__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): OpenBloxL1Interface {
    return new utils.Interface(_abi) as OpenBloxL1Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): OpenBloxL1 {
    return new Contract(address, _abi, signerOrProvider) as OpenBloxL1;
  }
}
